import { useEffect, useState } from 'react';
import { find } from 'lodash';
import MuiTabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Inbound_Message_Class } from '@occc/graphql';

type LocationLogActivityTabsProps = {
  children: any;
  onChange: (value: Inbound_Message_Class) => void;
  tabs: any[];
  activeTabValue: Inbound_Message_Class;
};

export const Tabs = (props: LocationLogActivityTabsProps) => {
  const { activeTabValue, onChange, tabs, children } = props;
  const [activeTabState, setActiveTabState] = useState<Inbound_Message_Class>(activeTabValue);

  const handleChange = (
    _event: React.SyntheticEvent<Element, Event>,
    value: Inbound_Message_Class,
  ) => {
    setActiveTabState(value);
  };

  useEffect(() => {
    if (onChange) {
      onChange(activeTabState);
    }
  }, [activeTabState, onChange]);

  const tabsComponent = (
    <MuiTabs value={activeTabState} onChange={handleChange} indicatorColor='primary'>
      {Array.isArray(tabs) &&
        tabs.map((tab) => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
    </MuiTabs>
  );

  const activeTab = Array.isArray(tabs) ? find(tabs, (tab) => tab.value === activeTabState) : null;

  if (activeTab) {
    const { content, ...rest } = activeTab;
    return children(tabsComponent, content, rest);
  }

  return children(tabsComponent);
};
